import React, { useMemo, useState } from 'react'

import { Button, Input, SelectDropdown } from 'shared/components'
import { useQuery, useWindowSize } from 'shared/hooks'
import { transformSortOptions } from 'shared/pipes'
import { stringToArray } from 'shared/utils'

import { sorByOptions } from '../consts'
import { MobileFilters } from '../MobileFilters/MobileFilters'
import classes from './Search.module.scss'

type Props = {
  setIsMore: (m: boolean) => void
}

export const CatalogSearch = ({ setIsMore }: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)
  const [query, setQuery] = useQuery()
  const { isLargeDesktop, isDesktop } = useWindowSize()

  const defaultValue = sorByOptions[0]

  const renderOption = (v: string) => transformSortOptions(v)

  const getLength = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { page, filmName, sortBy, ...rest } = query
    return Object.values(rest)?.reduce(
      (acc, currentValue) => {
        const arr = stringToArray(currentValue)?.length || 0
        return acc + arr
      },
      filmName ? 1 : 0
    )
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoLength = useMemo(() => getLength(), [query])

  const renderFilters = () => {
    if (isLargeDesktop || isDesktop) {
      return (
        <Input
          icon="icon-search"
          value={query?.filmName || ''}
          onChange={e => setQuery({ filmName: e.target.value, page: '1' })}
          onClear={() => setQuery({ filmName: '', page: '1' })}
          placeholder="Поиск по названию"
        />
      )
    }

    return (
      <>
        <Button
          btnType="secondary_light"
          size="small"
          onClick={() => setIsOpen(true)}
        >
          {memoLength > 0 && (
            <span className={classes.count}>{memoLength}</span>
          )}
          Фильтры
        </Button>
        <MobileFilters
          setIsMore={setIsMore}
          isOpen={isOpen}
          setIsOpen={() => setIsOpen(false)}
        />
      </>
    )
  }

  return (
    <div className={`${classes.row} row`}>
      <div className="col-xs-3">{renderFilters()}</div>

      <div className={`${classes.sort_container} col`}>
        <SelectDropdown
          options={sorByOptions}
          value={query?.sortBy || defaultValue}
          onClick={v => {
            setIsMore(false)
            setQuery({ ...query, sortBy: v, page: '1' })
          }}
          renderOption={renderOption}
          dropDownRight
        />
      </div>
    </div>
  )
}
